const mapBlock = document.querySelector(".google-map");
if (mapBlock) {
    let map;
    let markers = [];
    const activeclass = "google-map__card--active";
    const mapElement = document.querySelector(".google-map__wrapper");
    const cards = mapElement.querySelectorAll("[data-map-card]");

    function initMap() {
        map = new google.maps.Map(document.getElementById("map"), {
            center: {
                lat: 52.83050583070451,
                lng: 0.8555347755931285,
            },
            zoom: 14,
            mapTypeControl: false,
            streetViewControl: false,
            styles:[
                {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f7f1df"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#d0e3b4"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural.terrain",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.business",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.medical",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#fbd3da"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#bde6ab"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffe15f"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#efd151"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "black"
                        }
                    ]
                },
                {
                    "featureType": "transit.station.airport",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#cfb2db"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#a2daf2"
                        }
                    ]
                }
            ]
        });

        var bounds = new google.maps.LatLngBounds();

        const icon = {
            url: "/app/themes/adaptable/assets/dist/vectors/marker.svg",
            anchor: new google.maps.Point(21, 56),
            scaledSize: new google.maps.Size(42, 56),
        };

        const iconCluster = {
            url: "/app/themes/adaptable/assets/dist/vectors/clustermarker.svg",
            scaledSize: new google.maps.Size(50, 50),
            anchor: new google.maps.Point(25, 37.5),
        };

        // create markers from the cards const
        Array.from(cards).forEach((card) => {
            const lat = card.dataset.lat;
            const lng = card.dataset.lng;
            const title = card.dataset.mapCard;

            const marker = new google.maps.Marker({
                position: {
                    lat: parseFloat(lat),
                    lng: parseFloat(lng),
                },
                map: map,
                icon: icon,
                id: title,
            });

            bounds.extend(marker.position);

            markers.push(marker);

            // When the marker is clicked
            marker.addListener("click", () => {
                // Get the correspondng card ID
                const cardId = marker.id;
                // Fetch the card by the matching ID
                const card = document.querySelector(
                    `[data-map-card="${cardId}"]`
                );
                // Remove the active state from all other marker cards
                Array.from(cards).forEach((mapMarker) => {
                    mapMarker.classList.remove(activeclass);
                });

                // Set the current markers' card to active to show the information
                if (typeof card != "undefined" && card != null) {
                    card.classList.add(activeclass);
                }
            });
        });

        map.fitBounds(bounds);

        const renderer = {
            render: ({ count, position }) =>
                new google.maps.Marker({
                    icon: iconCluster,
                    label: {
                        text: String(count),
                        color: "#0C4944",
                        fontSize: "14px",
                        fontFamily:"national-regular",
                    },
                    position,
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                }),
        };

        new markerClusterer.MarkerClusterer({
            markers,
            map,
            renderer,
        });
    }

    window.initMap = initMap;

    // When the close button is clicked
    Array.from(cards).forEach((card) => {
        const closeButton = card.querySelector("[data-close-button]");

        closeButton.addEventListener("click", () => {
            // Remove the active state from all other marker cards
            Array.from(cards).forEach((mapMarker) => {
                mapMarker.classList.remove(activeclass);
            });
        });
    });
}
